const getBmiStatus = (bmi: number) => {
  let bmiStat = "Healthy";

  if (bmi <= 18.5) bmiStat = "Underweight";
  if (bmi >= 18.6 && bmi <= 25.0) bmiStat = "Healthy";
  if (bmi >= 25.1 && bmi <= 35.0) bmiStat = "Moderately Overweight";
  if (bmi >= 35.1 && bmi <= 40.0) bmiStat = "Severely Overweight";
  if (bmi >= 40.1) bmiStat = "Very Severely Overweight";

  return bmiStat;
};

export { getBmiStatus };
